<template>
	<BaseCard
		:is-editable="!isProcessFinished && isEditAllowed"
		:title="title"
		@clickEdit="$router.push({ name: editRoute })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<template #icons>
			<div class="flex items-center" v-if="isEditAllowed">
				<font-awesome-icon v-if="showWarn" class="text-red-700" icon="exclamation-triangle" />
			</div>
		</template>

		<div v-if="company">
			<div class="mb-4">
				<div class="mr-4">
					<BaseCardRow :value="company.name" :missing-label="$t('name')"></BaseCardRow>
					<BaseCardRow v-if="street != null" :value="street" :missing-label="$t('street')" />
					<BaseCardRow v-else :value="company.poBox" :missing-label="$t('po_box')" />
					<BaseCardRow :value="city" :missing-label="$t('city')" />
					<BaseCardRow :value="phoneNumber" :label="$t('phone')" :missing-label="$t('phone')" class="mt-6"></BaseCardRow>
					<BaseCardRow :value="email" :missing-label="$t('e_mail')"></BaseCardRow>
					<BaseCardRow :value="damageCase.opposite_case_number" :label="$t('case_number')" class="mt-6" />
					<BaseCardRow :value="damageCase.opposite_insurance_contract_number" :label="$t('contract_number')" />
				</div>
			</div>
		</div>
		<div v-else-if="damageCase.opposite_insurance_state">
			<BaseCardRow :value="oppositeInsuranceStateLabel" :label="$t('status')" />
			<BaseCardRow :value="damageCase.opposite_case_number" :label="$t('case_number')" />
			<BaseCardRow :value="damageCase.opposite_insurance_contract_number" :label="$t('contract_number')" />
		</div>

		<div class="font-bold" v-else>
			{{ getMissingValue }}
		</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';
import OppositeInsuranceStatus from '@/mixins/damagecase/OppositeInsuranceStatus';

export default {
	name: 'OppositeInsurenceCard',
	components: { BaseCard, BaseCardRow },
	mixins: [Authentication, OppositeInsuranceStatus],
	props: {
		company: { required: true },
		isProcessFinished: {},
		missingValue: {
			default: function() {
				return this.$t('contact_data_not_stored');
			},
		},
		customerConsultant: { default: false },
		damageCase: { required: true },
		isToggleOpen: { type: Boolean, default: true },
	},
	computed: {
		oppositeInsuranceStateLabel() {
			const status = this.oppositeInsuranceStatus.find(option => option.value === this.damageCase.opposite_insurance_state);
			if (this.damageCase.opposite_insurance_state === 'ohne_versicherung_selbstzahler' && this.damageCase.process_type === 'comprehensive') {
				return this.$t('without_insurance_self_paid');
			}
			return status ? status.display : null;
		},
		showWarn() {
			return !this.damageCase.oppositeInsurance && !this.damageCase.opposite_insurance_state && this.isUserAllowedInLevel2;
		},
		title() {
			return this.$store.getters.isProcessComprehensive ? this.$t('comprehensive_insurance') : this.$t('opponent_insurance');
		},
		editRoute() {
			return 'damagecases.edit.oppositeInsurance';
		},
		isEditAllowed() {
			return this.isUserAllowedInLevel1 || this.isUserAllowedInLevel2 || this.isUserAllowedInLevel3 || this.isUserAllowedInLevel5or6;
		},
		getMissingValue() {
			return this.missingValue || this.title + ' ' + this.$t('not_stored');
		},
		street: function() {
			if (this.company.street === undefined) {
				return null;
			}
			return concatArray([this.company.street, this.company.houseNumber]);
		},
		city() {
			return concatArray([this.company.city.zipCode, this.company.city.name]);
		},
		customerConsultantName: function() {
			if (this.customerConsultant.gender === 'company') {
				return concatArray([this.genderTitle, this.customerConsultant.company.name]);
			}
			return concatArray([this.genderTitle, this.customerConsultant.title, this.customerConsultant.firstName, this.customerConsultant.lastName]);
		},
		phoneNumber: function() {
			if (this.showCustomerConsultantPhoneNumber) return this.customerConsultant?.cellNumber || this.customerConsultant?.phoneNumber;
			else return this.company.phoneNumber;
		},
		email: function() {
			if (this.showCustomerConsultantEmail) return this.customerConsultant.email;
			else return this.company.email;
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
};
</script>
